import type { FleetRun, FleetRunGrade } from './claude-fleet.types'

/**
 * People's 👍 / 👎 on a run: one each, changeable. A 👎 with a reason becomes something the fleet's
 * knowledge loop learns from. Not the daily eval's model grade (`judge`).
 */

export const FLEET_RUN_GRADED = ['any', 'up', 'down'] as const
export type FleetRunGraded = (typeof FLEET_RUN_GRADED)[number]

export const FLEET_GRADED_LABELS: Record<FleetRunGraded, string> = {
  any: 'Graded by people',
  up: 'Graded 👍',
  down: 'Graded 👎'
}

/** The fleet's limit on a reason: one line. */
export const GRADE_WHY_MAX = 200

export interface FleetGradeTally {
  up: number
  down: number
}

export function gradeTally(run: Pick<FleetRun, 'grades'>): FleetGradeTally {
  const grades = run.grades ?? []
  return {
    up: grades.filter(g => g.grade === 'up').length,
    down: grades.filter(g => g.grade === 'down').length
  }
}

/** "👍 2 · 👎 1", or '' when nobody has graded the run. */
export function gradeTallyText(run: Pick<FleetRun, 'grades'>): string {
  const { up, down } = gradeTally(run)
  return [up ? `👍 ${up}` : '', down ? `👎 ${down}` : ''].filter(Boolean).join(' · ')
}

export function myGrade(
  run: Pick<FleetRun, 'grades'>,
  email: string | null | undefined
): FleetRunGrade | null {
  const me = email?.toLowerCase()
  return (me && run.grades?.find(g => g.by.toLowerCase() === me)) || null
}

export function runGradedAs(run: Pick<FleetRun, 'grades'>, graded: FleetRunGraded): boolean {
  const grades = run.grades ?? []
  return graded === 'any' ? grades.length > 0 : grades.some(g => g.grade === graded)
}

/** Who graded, as the panel names them: their name, else their email's local part. */
export function graderName(grade: FleetRunGrade): string {
  return grade.name || grade.by.split('@')[0]
}
